import React, { useContext } from 'react';
import { object, node, shape, string } from 'prop-types';

import InventoryTableContext from './InventoryTableContext';
import EditableDataTypeFormatter from './EditableDataTypeFormatter';
import EditableIntervalFormatter from './EditableIntervalFormatter';

const EditableFormatter = ({ column, row, value }) => {
    const { onCellChange } = useContext(InventoryTableContext);
    if (!row.isLeaf) {
        return null;
    }
    switch (column.name) {
        case 'dataType':
            return (
                <EditableDataTypeFormatter
                    name={column.name}
                    onChange={onCellChange}
                    row={row}
                />
            );
        case 'sampleInterval':
            return (
                <EditableIntervalFormatter
                    name={column.name}
                    onChange={onCellChange}
                    row={row}
                />
            );
        default:
            return value;
    }
};

EditableFormatter.defaultProps = {
    column: {},
    row:    {}
};

EditableFormatter.propTypes = {
    column: shape({
        name: string
    }),
    row:   object,
    value: node
};

export default EditableFormatter;
